export default {
    SERVICE_ID: "tecworkshop-gmail",
    TEMPLATE_ID: "tec-workshop-contact",
    USER_ID: "user_mFnkuUlzk3uR1TBfpV4qT",
};